import React, { ChangeEvent, ReactElement, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import MySelect from '../formGroup/MySelect'
import { LOGEMENT } from './Options'
import LogementBuilder from './LogementBuilder'
import { ILogementProps } from '../../interfaces/Logement'
import useUploadHook from '../../hooks/UseUploadHook'
import { STATUS } from '../../enums/common'
import { getOptionLabelByValue, handleError } from '../../services/utils'
import kycCore from '../../services/Kyc'
import { useTriggerChangeHook } from '../../hooks/triggerChangeHook'
import { personActions } from '../../store/slices/Person'
import { IStore } from '../../interfaces/Store'

const index = 0
function Logement(props: ILogementProps): ReactElement {
  const {
    register,
    errors,
    state,
    setState,
    validateFile,
    watch,
    address,
    showUploadSelect,
  } = props
  const watchSituationLogement = watch('situation_logement')
  const personStatus = useSelector(
    (store: IStore) => store.personReducer.status
  )

  const { handleChange } = useUploadHook({
    index,
    setState,
    mainState: state,
    validateFile,
  })
  const dispatch = useDispatch()
  const history = useHistory()
  const situation_logement = useTriggerChangeHook('situation_logement')
  const name = 'situation_logement'
  const { status } = state[0]

  const createPerson = async () => {
    if (personStatus === STATUS.idle) {
      const { person } = kycCore
      try {
        dispatch(personActions.personPending())
        await person.createPerson({ personTypeId: '2' })
        dispatch(personActions.personLoaded())
      } catch (e) {
        dispatch(personActions.personLoaded())
        handleError(e, history)
      }
    }
  }

  const onSelectChange = async (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target
    if (['2', '4'].includes(value)) {
      await createPerson()
    }
    setState((prevState) => {
      const indexPrevState = prevState[index]
      const newState = [...prevState]
      newState[index] = {
        ...indexPrevState,
        docValue: value,
      }
      return newState
    })

    await handleChange(event, true)
  }

  const handleSelectChange = async (event: ChangeEvent<HTMLSelectElement>) => {
    event.persist()
    await onSelectChange(event)
  }

  useEffect(() => {
    if (!showUploadSelect) {
      const event = { target: { value: '4' } } as ChangeEvent<HTMLSelectElement>
      onSelectChange(event).then()
    }
  }, [showUploadSelect])

  const label = 'Situation logement'

  const showSelect = status !== STATUS.validated
  let selectLabel = ''
  if (!showSelect) {
    selectLabel = getOptionLabelByValue(LOGEMENT, watchSituationLogement)
  }

  return (
    <>
      {showUploadSelect && (
        <>
          <div
            className={`${showSelect ? 'hidden' : ''} colLg6 ${
              address ? 'pl3lg' : 'pr3lg'
            } inputLabel`}
          >
            <span className="inputLabelRequired">{label}</span>
            <div className="textPrimary fontSizeSm mt1 fontWeightBold opacity65">
              {selectLabel}
            </div>
          </div>
          <MySelect
            register={register({ required: true })}
            options={LOGEMENT}
            value={situation_logement}
            error={errors[name]}
            id={name}
            name={name}
            label={label}
            required
            onChange={handleSelectChange}
            className={`${showSelect ? '' : 'hidden'} col12 colLg6 ${
              address ? 'pl3lg' : 'pr3lg'
            }`}
          />
        </>
      )}
      <LogementBuilder
        type={!showUploadSelect ? '4' : watchSituationLogement}
        {...props}
      />
    </>
  )
}

export default Logement
